import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export default class UnauthorizedLayoutService {
    public readonly loading$ = new BehaviorSubject<boolean>(false);
}
